
import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const UnspecifiedFormIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 24 24",
  path: (
    <>
      <Path
        d="M9 14.5H15M12 11.5V17.5M18.6627 8.93981C19.5257 9.9466 20 11.2289 20 12.5549V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V12.5549C4 11.2289 4.47434 9.9466 5.3373 8.93981C6.39263 7.7086 7.93328 7 9.55489 7H14.4451C16.0667 7 17.6074 7.7086 18.6627 8.93981ZM8.5 4.5H15.5C16.3284 4.5 17 3.82843 17 3C17 2.17157 16.3284 1.5 15.5 1.5H8.5C7.67157 1.5 7 2.17157 7 3C7 3.82843 7.67157 4.5 8.5 4.5Z"
        fill="none"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

UnspecifiedFormIcon.displayName = "UnspecifiedFormIcon";
export { UnspecifiedFormIcon };
